<template>
  <div>
    <router-view v-show="this.$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 操作按钮区域 -->
        <div class="action-card">

          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              添加角色
            </el-button>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-s-grid"></i>
              角色列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{list.length}} 条数据</span>
            </div>
          </div>
          <div class="table-content">
            <div class="modern-table">
              <ApeTable ref="apeTable" :data="list" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
                <el-table-column 
                  label="ID" 
                  align="center">
                  <template slot-scope="scope">
                    <div class="id-cell">{{scope.row.id}}</div>
                  </template>
                </el-table-column>
                <el-table-column 
                  label="角色信息"
                  >  
                  <template slot-scope="scope">
                    <div class="role-cell">
                      <div class="role-name">
                        <i class="el-icon-user-solid"></i>
                        {{scope.row.role_name}}
                      </div>
                      <div class="role-desc" v-if="scope.row.role_description">
                        <i class="el-icon-document"></i>
                        {{scope.row.role_description}}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column 
                  label="管理员类型"
                  align="center">  
                  <template slot-scope="scope">
                    <div class="super-cell">
                      <el-tag 
                        :type="scope.row.is_supper=='Y' ? 'danger' : 'success'"
                        size="medium">
                        <i class="el-icon-star-on" v-if="scope.row.is_supper=='Y'"></i>
                        <i class="el-icon-user" v-else></i>
                        {{scope.row.is_supper=='Y'?'超级管理员':'普通角色'}}
                      </el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column 
                  label="角色状态"
                  align="center">  
                  <template slot-scope="scope">
                    <div class="status-cell">
                      <el-switch 
                        v-if="scope.row.is_supper=='N'"
                        v-model="scope.row.role_status" 
                        :active-value="'1'"
                        :inactive-value="'0'"
                        active-color="#67C23A"
                        inactive-color="#F56C6C"
                        class="status-switch"
                        @change="changeStatus(scope.row)">
                      </el-switch>
                      <div v-else class="static-status">
                        <el-tag :type="scope.row.role_status=='1' ? 'success' : 'danger'" size="small">
                          {{scope.row.role_status=='1' ? '启用' : '禁用'}}
                        </el-tag>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                label="操作"
                align="center">
                  <template slot-scope="scope">
                    <div class="action-cell" v-if="scope.row.is_supper !== 'Y'">
                      <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="primary"
                          icon="el-icon-edit" 
                          class="table-action-btn edit-btn"
                          @click="editButton(scope.row.id)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="权限绑定" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="warning"
                          icon="el-icon-key" 
                          class="table-action-btn permission-btn"
                          @click="permissionsBinding(scope.row)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="成员管理" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="success"
                          icon="el-icon-s-custom" 
                          class="table-action-btn member-btn"
                          @click="manageMembers(scope.row)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除" placement="top-start" v-if="scope.row.is_supper=='N'">
                        <el-popconfirm
                          title="确定删除这个角色吗？"
                          @onConfirm="deleteButton(scope.row.id)">
                          <el-button
                            slot="reference"
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            class="table-action-btn delete-btn">
                          </el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                    <div class="action-cell system-role" v-else>
                      <el-tooltip placement="top">
                        <div slot="content">系统内置禁止操作</div>
                        <el-button 
                          circle 
                          type="warning" 
                          size="mini" 
                          icon="el-icon-warning"
                          class="warning-btn">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="成员管理" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="success"
                          icon="el-icon-s-custom"
                          class="table-action-btn member-btn"
                          @click="manageMembers(scope.row)">
                        </el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
    
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="rolesForm" label-position="right" label-width="96px">
          <el-form-item label="角色标识" prop="role_name">
            <el-input v-model="formData.role_name"></el-input>
          </el-form-item>
          <el-form-item label="角色状态" prop="role_status">
            <el-select v-model="formData.role_status">
              <el-option value="1">启用</el-option>
              <el-option value="0">禁用</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色说明" prop="role_description">
            <el-input v-model="formData.role_description"></el-input>
          </el-form-item>
        </el-form>        
      </template>
    </ModalDialog>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <!-- <p>api权限管理</p>
        <hr>
        <el-select v-model="apiRolePermissions" multiple placeholder="请选择操作权限" collapse-tags clearable >
          <el-option
            v-for="item in apiPermissionsList"
            :key="item.id"
            :label="item.permission_desc + '(' + item.permission_method + ')' "
            :value="item.id">
          </el-option>
        </el-select>         -->
        <p>菜单权限管理</p>
        <hr>
        <div class="drawer-roles-premissions">
          <el-cascader
            v-model="menuRolePermissions"
            :options="menuPermissionsList"
            collapse-tags
            :props="{ expandTrigger: 'hover',value: 'id',label: 'menu_name',children: 'children',multiple: true}"
            clearable></el-cascader> 
        </div>
        <p style="margin-bottom:10rem"></p>
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    ApeDrawer
  },
  data() {
    return {
      loadingStaus: true,
      dialogData:{
        eidit:false,
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      searchRolesCondition:{
        "current_page": 1,
        "page_size": 20,
        "query":"",
        "params":[""]
      },
      // 表格列表数据
      list:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 20,
        total: 0
      },
      // 表单结构
      formData: {
        display_name:''
      },
      // 表单验证
      rules: {
        role_name: [{required: true, message: '输入角色名称', trigger: 'blur' }],
        role_status: [{required: true, message: '请选择角色状态', trigger: 'blur' }],
        is_supper: [{required: true, message: '请选择是否是超管', trigger: 'blur' }],
        role_description: [{required: true, message: '请输入角色说明', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '权限绑定',
        width_height: '680px',
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      apiPermissionsList: [],
      apiRolePermissions: [],
      menuPermissionsList: [],
      menuRolePermissions: [],
      currentRoleId: null
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 切换页码操作
    async switchPaging() {
      this.loadingStaus=true
      let res= await this.$api.post('/service/system_role/list',this.searchRolesCondition)
      this.pagingData.total = res.data.page.total
      this.list=res.data.list
      this.loadingStaus=false
    },
    // 响应添加按钮
    async addButton() {
      this.dialogData.visible = true
      this.dialogData.title = '添加'
      this.dialogData.loading = false
      this.dialogData.eidit=false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.dialogData.visible = true
      this.dialogData.title = '编辑'
      this.dialogData.eidit=true
      let res = await this.$api.post('/service/system_role/detail',{id:id})
      console.log(res.data.detail)
      if (this.$apiSuccess(res)) {
        this.formData = res.data.detail
        this.dialogData.loading = false
      }else{
        this.$message.error(res.message)
      }
    },
    // 修改角色状态
    async changeStatus(row) {
      let res = await this.$api.post('/service/system_role/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('修改成功!')
      }else{
        this.$message.error(res.message)
      }
    },
    // form数据提交，请求接口
    async formSubmit() {
      let res 
      if(this.formData.id!=undefined&&this.formData.id != ""){
       res= await this.$api.post('/service/system_role/update',this.formData)
      }else{
        res= await this.$api.post('/service/system_role/create',this.formData)
      }
      if (this.$apiSuccess(res)) {
        this.$message.success('保存成功!')
        this.initFormData()
        this.switchPaging()
      }else{
        this.$message.error(res.message)
      }
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/system_role/delete',{id:id})
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.switchPaging()
      } else {
        this.$message.error(res.message)
      }
      
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['rolesForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initFormData()
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.formData = {
          role_name:'',
          role_status:'',
          is_supper:'',
          role_description:''
        }
        this.$refs['rolesForm'].resetFields()
      })
    },
    /** 将接口返回的「角色已选菜单树」转为 el-cascader(multiple) 需要的路径数组 [[父id,子id],...] */
    menuRoleTreeToCascaderPaths (tree) {
      const paths = []
      const roots = Array.isArray(tree) ? tree : []
      for (const node of roots) {
        const pid = node && (node.id != null && node.id !== '') ? String(node.id) : ''
        if (!pid) continue
        const kids = (node.children || node.Children || [])
        if (!Array.isArray(kids)) continue
        for (const ch of kids) {
          if (ch && ch.id != null && ch.id !== '') {
            paths.push([pid, String(ch.id)])
          }
        }
      }
      return paths
    },
    // 权限绑定
    async permissionsBinding(row) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.currentRoleId = row.id
      this.drawerData.title = '权限绑定'+'（ID'+row.id+'-'+row.display_name+'-'+row.name+'）'
      this.menuRolePermissions = []
      this.menuPermissionsList = []
      this.apiPermissionsList = []
      this.apiRolePermissions = []
      let res = await this.$api.post('/service/role/role_menu_permissions',{role_id:row.id})
      if (!this.$apiSuccess(res) || !res.data) {
        this.$message.error((res && res.message) ? res.message : '加载权限失败')
        this.$nextTick(() => { this.drawerData.loading = false })
        return
      }
      this.apiPermissionsList = res.data.api_permissions_list || []
      this.apiRolePermissions = (res.data.api_role_permissions || []).map((p) => p.id).filter(Boolean)
      this.menuPermissionsList = res.data.menu_permissions_list || []
      this.menuRolePermissions = this.menuRoleTreeToCascaderPaths(res.data.menu_role_permissions)
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 每一个权限组的全选状态
    checkedApiIndeterminate(v) {
      v.checked_status = false
      if (typeof(this.apiRolePermissions[v.id])==='undefined') {
        return false
      }
      if  (this.apiRolePermissions[v.id].length < v.children.length && this.apiRolePermissions[v.id].length > 0) {
        return true
      }
      if (this.apiRolePermissions[v.id].length == v.children.length) {
        v.checked_status = true
      }
      return false
    },
    // 处理点击每个组的全选
    handleApiCheckAll(v) {
      if (v.checked_status) {
        this.apiRolePermissions[v.id] = v.children.map((val)=>{return val.id})
      } else {
        this.apiRolePermissions[v.id] = []
      }
    },
     // 每一个权限组的全选状态
    checkedMenuIndeterminate(v) {
      v.checked_status = false
      if (typeof(this.menuRolePermissions[v.id])==='undefined') {
        return false
      }
      if  (this.menuRolePermissions[v.id].length < v.children.length && this.menuRolePermissions[v.id].length > 0) {
        return true
      }
      if (this.menuRolePermissions[v.id].length == v.children.length) {
        v.checked_status = true
      }
      return false
    },
    // 处理点击每个组的全选
    handleMenuCheckAll(v) {
      if (v.checked_status) {
        this.menuRolePermissions[v.id] = v.children.map((val)=>{return val.id})
      } else {
        this.menuRolePermissions[v.id] = []
      }
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.apiPermissionsList = []
      this.apiRolePermissions = []
      this.menuPermissionsList = []
      this.menuRolePermissions = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let params = {
        role_id: this.currentRoleId,
        menus_ids: this.menuRolePermissions,
        permissions_ids: this.apiRolePermissions, 
      }
      let res = await this.$api.post('/service/role/save_role_api_permissions',params)
      if (this.$apiSuccess(res)) {
        this.$message.success('保存成功!')
        this.drawerData.visible = false
      }else{
        this.$message.error(res.message)
      }
    },
    // 管理成员
    manageMembers(row) {
      window.open(this.$route.path+'/'+row.id+'/manage_members/', '_blank');
    }
  },
  async mounted() {
    this.switchPaging()
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0

// 表格单元格样式
.id-cell
  font-weight 600
  color #606266
  background #f5f7fa
  padding 4px 8px
  border-radius 4px
  display inline-block

.role-cell
  .role-name
    font-weight 600
    color #303133
    margin-bottom 4px
    display flex
    align-items center
    gap 6px
    
    i
      color #409EFF
      
  .role-desc
    font-size 12px
    color #909399
    display flex
    align-items center
    gap 4px
    
    i
      color #C0C4CC

.super-cell
  .el-tag
    border-radius 12px
    padding 0 8px
    height 28px
    line-height 26px
    font-weight 500
    
    i
      margin-right 4px

.status-cell
  .status-switch
    /deep/ .el-switch__core
      width 44px
      height 22px
      border-radius 11px
      
      &::after
        width 18px
        height 18px
        
  .static-status
    .el-tag
      border-radius 12px

.action-cell
  display flex
  gap 6px
  justify-content center
  align-items center
  
  &.system-role
    opacity 0.8
  
  .table-action-btn
    width 28px
    height 28px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.edit-btn
      background #409EFF
      border-color #409EFF
      
      &:hover
        background #66B3FF
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
    
    &.permission-btn
      background #E6A23C
      border-color #E6A23C
      
      &:hover
        background #EBB563
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(230,162,60,0.3)
        
    &.member-btn
      background #67C23A
      border-color #67C23A
      
      &:hover
        background #85CE61
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(103,194,58,0.3)
        
    &.delete-btn
      background #F56C6C
      border-color #F56C6C
      
      &:hover
        background #F78989
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(245,108,108,0.3)
  
  .warning-btn
    background #E6A23C
    border-color #E6A23C
    
    &:hover
      background #EBB563

// Drawer权限样式
.drawer-roles-premissions
  margin-top 16px
  
  /deep/ .el-cascader
    width 100%

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .table-card
    padding 16px
    
  .action-buttons
    flex-direction column
    
    .action-btn
      width 100%
      margin-bottom 8px
      
  .role-cell
    .role-name
      font-size 14px
      
    .role-desc
      font-size 11px
      
  .action-cell
    flex-wrap wrap
    gap 4px
    
    .table-action-btn
      width 24px
      height 24px
</style>
